<template>
    <div
        class="privacy mx-auto flex h-full min-h-full w-full max-w-6xl justify-center p-10 lg:p-20 xl:max-w-7xl"
    >
        <ContentDoc />
    </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

useSeoMeta({
    title: () => t('meta.title'),
    description: () => t('meta.description'),
})
</script>

<i18n lang="yaml">
en:
    meta:
        title: 'eFirma.bg - Privacy Policy'
        description: 'Privacy Policy of eFirma.bg'
bg:
    meta:
        title: 'eFirma.bg - Политика за поверителност'
        description: 'Политика за поверителност на eFirma.bg'
</i18n>

<style lang="postcss">
.privacy {
    h1 {
        @apply mb-10 text-3xl;
    }

    h2 {
        @apply mb-6 mt-10 text-xl;
    }

    p {
        @apply my-2;
    }

    p:first-of-type {
        @apply mb-10;
    }

    a {
        @apply text-blue-500 underline;
    }
}
</style>
